import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Employee } from '@app/models/employee/employee.model';
import { TimeOffBackupApprover } from '@app/models/time-off-v3/time-off-backup-approver.model';
import { SettingsToolTips } from '@app/modules/time-off-v3/meta/tooltip-meta';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-general-settings-edit-card',
    templateUrl: 'general-settings-edit-card.component.html',
    standalone: true,
    imports: [TranslateModule, PlatformModule, CommonModule, FormsModule],
})
export class GeneralSettingsEditComponent {
    // Default value for selected backup approver
    @Input() selectedBackupApprover = 0;
    @Input() timeOffVisibility = false;
    @Input() timeOffBalanceDateToday = false;
    @Input() activeAdmins: Employee[] = [];
    @Output() onUpdateBackupApprover = new EventEmitter<number>();
    @Output() onTrackLearnMoreBackupApprover = new EventEmitter();
    @Output() onTimeOffVisibilityChange = new EventEmitter<boolean>();
    @Output() onTimeOffBalanceDateTodayChange = new EventEmitter<boolean>();

    settingsToolTips = SettingsToolTips;

    currentTimeOffBackupApprover: TimeOffBackupApprover = new TimeOffBackupApprover();

    updateBackupApprover(matSelect: MatSelectChange): void {
        this.onUpdateBackupApprover.emit(matSelect.value);
    }

    timeOffVisibilityChange(event: boolean): void {
        this.onTimeOffVisibilityChange.emit(event);
    }

    timeOffBalanceDateTodayChange(event: boolean): void {
        this.onTimeOffBalanceDateTodayChange.emit(event);
    }

    trackLearnMoreBackupApprover(): void {
        this.onTrackLearnMoreBackupApprover.emit();
    }
}
